import React from "react";
import TextField from "@mui/material/TextField";
import { Box, Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ImgContext } from "../Context/ImageCon";
import axios from "axios";

const theme = createTheme();
function Contacts() {
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [url, setUrl] = React.useState("");
  let handleSubmit = (e) => {
    axios
      .post("contact/", {
        name: name,
        email: email,
        phone: phone,
        url: url,
      })
      .then((res) => {
        setImg(res.data.img);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <ThemeProvider theme={theme}>
      <Box
        className="ContactForm"
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{ mt: 1 }}
      >
        <TextField
          margin="normal"
          required
          fullWidth
          id="name"
          label="Full Name"
          name="name"
          autoComplete="Name"
          autoFocus
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="phone"
          label="Phone"
          type="phone"
          id="phone"
          autoComplete="current-Phone"
          onChange={(e) => setPhone(e.target.value)}
        />
        <TextField
          margin="normal"
          fullWidth
          name="url"
          label="url"
          type="url"
          id="url"
          autoComplete="current-url"
          onChange={(e) => setUrl(e.target.value)}
        />
        <Button
          style={{ marginTop: "12%" }}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Make QR
        </Button>
      </Box>
    </ThemeProvider>
  );
}

export default Contacts;
